import React, {useState} from "react";
import {LoginWrapper} from "../../login.wrapper";
import {observer} from "mobx-react";
import {ForgotPasswordCompleteStore} from "./forgot.password.complete.store";
import {Alert, Spin} from "antd";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {ForgotPasswordController} from "../forgot.password.controller";
import {forgotPasswordService} from "../../../../../services/forgot-password/forgot.password.service";
import {ForgotPasswordCompleteController} from "./forgot.password.complete.controller";

export const ForgotPasswordComplete: React.FC = observer(() => {
    const {t} = useTranslation('translation', {useSuspense: false});
    const [store] = useState(() => new ForgotPasswordCompleteStore());
    const [controller] = useState(() => new ForgotPasswordCompleteController(store, forgotPasswordService));

    return (
        <LoginWrapper title="FORGOT_PASSWORD.TITLE">
            {!store.inited ? (
                <Spin/>
            ) : (
                <>
                    <Alert
                        description={
                            t(store.completed ?
                                "FORGOT_PASSWORD.COMPLETE.SUCCESS" :
                                "FORGOT_PASSWORD.COMPLETE.ERROR"
                            )
                        }
                        type={store.completed ? "success" : "error"}
                        message={t(store.completed ?"SUCCESS" : "ERROR")}
                        showIcon
                    />
                    {store.completed ? (
                        <Link
                            to="/login"
                            className="ant-btn ant-btn-primary register-btn"
                            style={{width: "100%", marginTop: 20}}
                        >
                            {t("LOGIN.LOG_IN")}
                        </Link>
                    ) : null}
                </>
            )}
        </LoginWrapper>
    );
});